// extracted by mini-css-extract-plugin
export default {"ordersMain":"Orders_ordersMain__E5IS8","topLeft":"Orders_topLeft__lZeYU","myAccount":"Orders_myAccount__3h6Ee","home":"Orders_home__RXZ2r","myOrders":"Orders_myOrders__93wBs"};